import { Icon } from '~/components/ui/Icon';
import { useInstallPrompt } from '~/hooks/useInstallPrompt';

export function InstallPrompt(): JSX.Element | null {
  const { canInstall, install, dismiss } = useInstallPrompt();

  if (!canInstall) return null;

  return (
    <div
      style={{
        margin: '0 24px 16px',
        padding: 14,
        background: 'var(--rx-brand)',
        color: 'var(--rx-brand-ink)',
        borderRadius: 14,
        display: 'flex',
        alignItems: 'center',
        gap: 12,
      }}
    >
      <div
        style={{
          width: 36,
          height: 36,
          borderRadius: 10,
          background: 'rgba(255,255,255,0.12)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <Icon name="download" size={18} color="#ffffff" />
      </div>

      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 14, fontWeight: 500, letterSpacing: '-0.1px' }}>
          Instalar na tela inicial
        </div>
        <div style={{ marginTop: 2, fontSize: 12, opacity: 0.78, lineHeight: 1.4 }}>
          Abra como um app, receba push e funcione offline.
        </div>
      </div>

      <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
        <button
          type="button"
          onClick={dismiss}
          style={{
            padding: '8px 10px',
            background: 'transparent',
            border: 'none',
            color: 'rgba(255,255,255,0.7)',
            fontSize: 12,
            fontWeight: 500,
            cursor: 'pointer',
          }}
        >
          Depois
        </button>
        <button
          type="button"
          onClick={() => {
            void install();
          }}
          style={{
            padding: '8px 14px',
            background: 'rgba(255,255,255,0.95)',
            color: 'var(--rx-brand)',
            border: 'none',
            borderRadius: 8,
            fontSize: 12,
            fontWeight: 600,
            cursor: 'pointer',
            letterSpacing: '-0.1px',
          }}
        >
          Instalar
        </button>
      </div>
    </div>
  );
}
